import { render, staticRenderFns } from "./iconMinus.vue?vue&type=template&id=4e378e79&scoped=true"
import script from "./iconMinus.vue?vue&type=script&lang=js"
export * from "./iconMinus.vue?vue&type=script&lang=js"
import style0 from "./iconMinus.vue?vue&type=style&index=0&id=4e378e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e378e79",
  null
  
)

export default component.exports